var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-0 my-md-12"},[_c('PlatformDetail',{attrs:{"platform-id":_vm.platformId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }